/**
 * Nettoie les balises SEO generees par 'nuxt-i18n' via $nuxtI18nSeo
 *
 * Cette fonction supprime les balises hreflang du head HTML, afin d'eviter l'injection automatique des balises hreflang
 * dans le rendu de la page, vue que le site ne support plus la langue anglaise.
 *
 *
 * @param {Object} head l'object retourne par this.$nuxtI18nSeo
 * @returns {Object} Un objet 'head' nettoye, pret a etre retourne dans la method 'head()'
 *
 *@author Roger Sioufi roger.sioufi[at]makeitbloom.com
 */
export function getStrippedI18nSeo(head) {
    head.link = (head.link || []).filter(link => !link.hreflang);

    head.link = head.link.map(link => {
        if (link.href) {
            return {
                ...link,
                href: decodeURIComponent(link.href),
            };
        }
        return link;
    });
    return head;
}
